interface EnumType {
  [key: string]: string | number;
}

//enum value값으로 key값 구하는 함수.
export const getEnumKeyByValue = <T extends EnumType>(enumObj: T, value: string | number): keyof T | null => {
  for (const key in enumObj) {
    if (enumObj[key] === value) {
      return key as keyof T;
    }
  }
  return null;
};
